module.exports = "<div class=\"group-player\">\r\n\t<div class=\"player-image\"\r\n\t\tstyle=\"background-image: url(<%- data.photoURL %>)\">\r\n\t</div>\r\n\t<span><%- data.name %></span>\r\n\t<span><%- data.surname %></span>\r\n\t<button class=\"btn btn-xs btn-danger btn-remove\">\r\n\t\tRemove\r\n\t</button>\r\n\t<div class=\"clearfix\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin-section/groups/group/group-player/group-player.tpl.html
// module id = 83
// module chunks = 0